module.exports = __webpack_public_path__ + "img/symbol_3.2fc44448.png";